<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="customerPricingHeadings" :data="customerPricing" :hasNoFilter="true" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onPricingActionClicked">
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

<!--    <mark-as-active-inactive-modal-->
<!--            :heading="productMarkAsActiveInactiveModal.heading"-->
<!--            :modalId="productMarkAsActiveInactiveModal.modalId"-->
<!--            :isSaving="productMarkAsActiveInactiveModal.isSaving"-->
<!--            :showModal="productMarkAsActiveInactiveModal.showModal"-->
<!--            :isActive="productMarkAsActiveInactiveModal.isActive"-->
<!--            @closeClicked="productMarkAsActiveInactiveModal.showModal = false"-->
<!--            @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>-->

</div>
